import { useApiInspectionsV1Retrieve } from 'api';
import { useEffect, useState } from 'react';
import { Box, CenteredLoader, Grid } from 'ui';

import { DealAutocomplete, DealDetails } from '../../../deal';
import { DealLoads, InspectionLoadAssigner } from '../../../inspection-load';
import { InspectionMutate } from '../InspectionMutate/InspectionMutate';

export const InspectionDetails = ({ inspectionId }: { inspectionId?: number }) => {
  const [currentDeal, setCurrentDeal] = useState<number | undefined>(undefined);

  const { data: inspection, isFetching } = useApiInspectionsV1Retrieve(inspectionId ?? 0, {
    query: {
      enabled: !!inspectionId,
    },
  });

  useEffect(() => {
    if (inspection?.deal) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setCurrentDeal(inspection?.deal);
    }
  }, [inspection]);

  if (isFetching) {
    return <CenteredLoader />;
  }

  if (inspectionId && !inspection) {
    throw new Error('Inspection not found');
  }

  return (
    <Grid container>
      <Grid
        size={{
          sm: 4,
        }}
      >
        <Box
          sx={{
            p: 2,
          }}
        >
          <InspectionMutate inspection={inspection} dealId={currentDeal} variant={inspectionId ? 'update' : 'create'} />
        </Box>
      </Grid>
      <Grid
        size={{
          sm: 8,
        }}
      >
        <Box
          sx={{
            pt: 2,
            px: 2,
          }}
        >
          <Box
            sx={{
              mb: 2,
            }}
          >
            {!inspection?.deal && (
              <DealAutocomplete
                required
                defaultValue={currentDeal}
                onSelectDeal={(deal) => {
                  setCurrentDeal(deal?.id);
                }}
              />
            )}
          </Box>

          {currentDeal ? (
            <Grid container spacing={2}>
              <Grid
                size={{
                  sm: 8,
                }}
              >
                <DealDetails dealId={currentDeal} />
              </Grid>
              <Grid
                size={{
                  sm: 4,
                }}
              >
                {inspection?.deal ? (
                  <InspectionLoadAssigner
                    inspectionId={inspection?.id}
                    inspectionSlug={inspection?.slug}
                    dealId={inspection.deal}
                  />
                ) : (
                  <DealLoads dealId={currentDeal} />
                )}
              </Grid>
            </Grid>
          ) : null}
        </Box>
      </Grid>
    </Grid>
  );
};
